import { cloneDeep } from "lodash";
import { productImage } from "../../utilities";
import {
  UPDATE_PRODUCT_PARAMS,
  REQUEST_PRODUCTS,
  RECEIVE_PRODUCTS,
  REQUEST_PRODUCT,
  RECEIVE_PRODUCT,
  REQUEST_PRODUCT_VIDEOS,
  RECEIVE_PRODUCT_VIDEOS,
  REQUEST_PRODUCT_INFLUENCERS,
  RECEIVE_PRODUCT_INFLUENCERS,
  REQUEST_PRODUCT_NAMES,
  RECEIVE_PRODUCT_NAMES,
  RECEIVE_CREATE_PRODUCT,
  REMOVE_ADDED_PRODUCT_INFO,
  REQUEST_ADD_PRODUCT_HASHTAG,
  RECEIVE_AUTO_COMPLETE_PRODUCT_OR_HASHTAG_LIST,
  RECEIVE_AUTO_COMPLETE_PRODUCT_OR_HASHTAG_CATEGORIES,
  RECEIVE_PRODUCT_ERRORS,
  RESET_FILTERS_PRODUCTS,
  REQUEST_EDIT_PRODUCT_HASHTAG,
  RECEIVE_UPDATE_PRODUCT,
  RECEIVE_PRODUCT_UPDATE_ERRORS,
  CLEAR_UPDATED_PRODUCT_DATA,
  RESET_PRODUCTS_DATA,
  PRODUCT_PAGE_STATES,
} from "./productActions";
import { RECEIVE_CURRENT_SESSION } from "../../Entry/session_actions";

export const _nullProducts = [];
export const products = (state = _nullProducts, payload = {}) => {
  const { type, products, product } = payload;
  switch (type) {
    case RECEIVE_PRODUCTS:
      return products;
    case RECEIVE_PRODUCT:
      const newState = cloneDeep(state);
      const i = state.findIndex((p) => p._id === product._id);
      if (i === -1) {
        return [product];
      }
      newState[i] = product;
      return newState;
    case RESET_PRODUCTS_DATA:
      return _nullProducts;
    default:
      return state;
  }
};

const filters = {
  note: [],
  category: [],
  influencer: [],
  brand: [],
};

export const _nullParams = {
  desc: true,
  tab: "My Products",
  filters,
  trending: false,
  page: 1,
  isTrashTab: false,
  isFavoriteTab: false,
};

export const productParams = (state = _nullParams, payload = {}) => {
  const { type, params } = payload;
  switch (type) {
    case RESET_FILTERS_PRODUCTS:
      return { ...state, filters };
    case UPDATE_PRODUCT_PARAMS:
      return { ...state, ...params };
    case RECEIVE_CURRENT_SESSION:
      return _nullParams;
    default:
      return state;
  }
};

export const autoCompleteProductOrHashtagList = (state = {}, payload = {}) => {
  const { type, data } = payload;
  switch (type) {
    case RECEIVE_AUTO_COMPLETE_PRODUCT_OR_HASHTAG_LIST:
      return { ...state, data };
    default:
      return state;
  }
};

export const autoCompleteProductOrHashtagCategories = (
  state = {},
  payload = {}
) => {
  const { type, data } = payload;
  switch (type) {
    case RECEIVE_AUTO_COMPLETE_PRODUCT_OR_HASHTAG_CATEGORIES:
      return { ...state, data };
    default:
      return state;
  }
};

export const createProduct = (state = {}, payload = {}) => {
  const { type, data, name } = payload;

  switch (type) {
    case REQUEST_ADD_PRODUCT_HASHTAG:
      return {
        ...state,
        name,
        loading: true,
        error: undefined,
        success: undefined,
      };
    case RECEIVE_CREATE_PRODUCT:
      return {
        ...state,
        success: data,
        loading: false,
        added: true,
        error: undefined,
      };
    case REMOVE_ADDED_PRODUCT_INFO:
      return {
        ...state,
        name: "",
        loading: false,
        added: false,
      };
    case RECEIVE_PRODUCT_ERRORS:
      const { xhr } = payload;
      return { ...state, error: xhr, success: undefined };
    default:
      return state;
  }
};

export const updateProduct = (state = {}, payload = {}) => {
  const { type, data } = payload;

  switch (type) {
    case REQUEST_EDIT_PRODUCT_HASHTAG:
      return {
        ...state,
        loading: true,
        error: undefined,
        success: undefined,
      };
    case RECEIVE_UPDATE_PRODUCT:
      return {
        ...state,
        success: data,
        loading: false,
        error: undefined,
      };
    case RECEIVE_PRODUCT_UPDATE_ERRORS:
      const { xhr } = payload;
      return { ...state, error: xhr, success: undefined };
    case CLEAR_UPDATED_PRODUCT_DATA:
      return { ...state, loading: false, error: undefined, success: undefined };
    default:
      return state;
  }
};

const _nullData = {
  filters,
  loading: false,
  loadingVideos: false,
  loadingInfluencers: false,
  loadingNames: false,
  videos: { trending: [], recent: [] },
  influencers: { trending: [], popular: [] },
  pictures: [],
  names: [],
  loaded_for: null,
  totalPages: 1,
  count: 0,
  // isCategoryPage: true,
};

export const productData = (state = _nullData, payload = {}) => {
  const { type, data, videos, influencers, pictures, id, names } = payload;
  switch (type) {
    case REQUEST_PRODUCTS:
      return { ...state, loading: true };
    case RECEIVE_PRODUCTS:
      return { ...data, loading: false };
    case REQUEST_PRODUCT_VIDEOS:
      return { ...state, loadingVideos: id };
    case RECEIVE_PRODUCT_VIDEOS:
      if (state.loadingVideos === id) {
        return { ...state, videos, loadingVideos: false };
      }
      return { ...state }; // DO: stop loading?
    case REQUEST_PRODUCT_INFLUENCERS:
      return { ...state, loadingInfluencers: id };
    case RECEIVE_PRODUCT_INFLUENCERS:
      if (state.loadingInfluencers === id) {
        return { ...state, influencers, loadingInfluencers: false };
      }
      return { ...state }; // DO: stop loadingInfluencers?
    case REQUEST_PRODUCT:
      return { ...state, loading: true };
    case RECEIVE_PRODUCT:
      if (productImage({ _id: id }, state.pictures)) {
        return { ...state, loading: false };
      }
      return {
        ...state,
        pictures: [...state.pictures, ...pictures],
        loading: false,
      };
    case REQUEST_PRODUCT_NAMES:
      return { ...state, loadingNames: true };
    case RECEIVE_PRODUCT_NAMES:
      return { ...state, names, loadingNames: false };
    default:
      return state;
  }
};

const _nullPageState = {
  isCategoryPage: true,
  itemId: "",
  moveToTrashModal: false,
  movedToTrash: false, //Single item
  removedFromTrash: false,
  showchecks: false,
  itemsCheckList: [],
  selectAllChecks: false,
  permanentDeleteModal: false,
  unFavoriteModal: false,
  modalFor: "product",
  // isProcessSuccessfull: false,
  restoreFromTrashModal: false,
  isDetailPage: false,
  processType: "",
};

export const productPageStates = (state = _nullPageState, { type, status }) => {
  switch (type) {
    case PRODUCT_PAGE_STATES:
      return { ...state, ...status };
    default:
      return state;
  }
};
